import styled from "styled-components";
import Palette from "../../palette.json";

export const UsingTemplateMessage = styled.div`
  margin-bottom: 20px;
  margin-left: 25px;
  font-size: 14px;
  color: ${Palette.LightGrey};
`;
